import { gql } from '../__generated__';

export const GET_REVISIONS_WITH_USER = gql(/* GraphQL */ `
  query GetRevisionsWithUser {
    revisions(where: { and: [{ completedAt: { eq: null } }, { canceledAt: { eq: null } }] }) {
      id
      progress
      currentPhase
      authors {
        id
        name
      }
      professionQualityAssurers {
        id
        name
      }
      projectLeads {
        id: subjectId
        name
      }
      internalQualityAssurers {
        id: subjectId
        name
      }
      peerReviewers {
        id: subjectId
        name
      }
      dacs {
        id: subjectId
        name
      }
      publishingEditors {
        id: subjectId
        name
      }
      guide {
        id
        docName
        docTitle
        owner {
          id: subjectId
          name
        }
      }
    }
  }
`);

export const GET_CATEGORIES_FOR_USER = gql(/* GraphQL */ `
  query GetCategoriesForUser($ownerId: UUID) {
    categories(order: { title: ASC }, where: { ownerId: { eq: $ownerId } }) {
      id
      title
    }
  }
`);

export const GET_RELEASES_FOR_USER = gql(/* GraphQL */ `
  query GetReleasesForUser($userId: UUID) {
    releases: guideReleases(where: { ownerId: { eq: $userId } }) {
      id
      guideId
      docNumber
      docName
      docId
      title
      publishedAt
      archivedAt
      projectLeader
      version
    }
  }
`);

export const GET_USER = gql(/* GraphQL */ `
  query GetUser($userId: UUID!) {
    users: users(where: { subjectId: { eq: $userId } }) {
      subjectId
      canPublish
      canEditDictionary
      receiveEmailNotifications
    }
  }
`);

export const TOGGLE_EMAIL_NOTIFICATIONS = gql(/* GraphQL */ `
  mutation UpdateUserReceiveEmailNotifications($input: UserUpdateReceiveEmailNotificationsInput!) {
    userUpdateReceiveEmailNotifications(input: $input) {
      user {
        subjectId
        receiveEmailNotifications
      }
    }
  }
`);

export const GET_COMMENTS_ON_GUIDES_FOR_USER = gql(/* GraphQL */ `
  query GetCommentsOnGuidesForUser($ownerId: UUID!, $take: Int) {
    comments: commentsForOwner(ownerId: $ownerId, first: $take, order: [{ lastActivityAt: DESC }]) {
      nodes {
        id
        text
        status
        guide {
          id
          docName
          docTitle
          owner {
            subjectId
            name
          }
        }
        externalUserEmail
        createdBy {
          subjectId
          name
        }
        createdAt
        updatedBy {
          subjectId
          name
        }
        updatedAt
        closedAt
        replies {
          id
          comment
          createdBy {
            subjectId
            name
          }
          createdAt
          updatedAt
        }
      }
    }
  }
`);

export const GET_EXTERNAL_COMMENTS_FOR_OWNER = /* GraphQL */ gql(`
query GetExternalCommentsForOwner($ownerId: UUID!) {
    comments: commentsForOwner(ownerId: $ownerId, where: { and: [{ status: { eq: OPEN } }, { type: { eq: CUSTOMER_FEEDBACK } }] }, first: 50, order: { createdAt: DESC }) {
      nodes {
        id
        text
        status
        createdAt
        createdBy {
          subjectId
          name
        }
        externalUserEmail
        guide {
          id
          docName
          docTitle
        }
      }
    }
  }
`);

export const GET_COMMENTS_ON_GUIDES_FOR_USER_WITH_ACTIVITY_SINCE = gql(/* GraphQL */ `
  query GetCommentsOnGuidesForUserWithActivitySince($ownerId: UUID!, $since: DateTime!) {
    comments: commentsForOwner(
      ownerId: $ownerId
      where: { and: [{ type: { eq: CUSTOMER_FEEDBACK } }, { status: { eq: OPEN } }, { createdAt: { gt: $since } }] }
    ) {
      nodes {
        id
      }
    }
  }
`);

export const GET_EXTERNAL_CATEGORY_COMMENTS_FOR_OWNER = gql(/* GraphQL */ `
  query GetExternalCategoryCommentsForOwner($ownerId: UUID!) {
    comments: categoryCommentsForOwner(
      ownerId: $ownerId
      where: { and: [{ status: { eq: OPEN } }, { type: { eq: CUSTOMER_FEEDBACK } }] }
      first: 50
      order: { createdAt: DESC }
    ) {
      nodes {
        id
        text
        status
        createdAt
        createdBy {
          subjectId
          name
        }
        externalUserEmail
        category {
          id
          title
        }
      }
    }
  }
`);

export const GET_CATEGORY_COMMENTS_FOR_OWNER_WITH_ACTIVITY_SINCE = gql(/* GraphQL */ `
  query GetCategoryCommentsForOwnerWithActivitySince($ownerId: UUID!, $since: DateTime!) {
    comments: categoryCommentsForOwner(
      ownerId: $ownerId
      where: { and: [{ type: { eq: CUSTOMER_FEEDBACK } }, { status: { eq: OPEN } }, { createdAt: { gt: $since } }] }
    ) {
      nodes {
        id
      }
    }
  }
`);
